import axios from 'axios';

/**
 * Fetches the Monthly UBT Reports link from the MonthlyReport.txt file.
 * The file contains a single SharePoint URL without any additional characters.
 * 
 * @returns {Promise<string>} A promise that resolves to the Monthly Report link URL.
 * @throws {Error} If the fetch fails or the response is empty.
 */
export async function fetchMonthlyReportLink(): Promise<string> {
  try {
    const response = await axios.get<string>('/assets/landingPagePDF/MonthlyReport.txt', {
      responseType: 'text',
      transformResponse: [(data: string) => data], // Prevent JSON parsing
    });
    
    const link = response.data.trim();
    
    if (!link) {
      throw new Error('Monthly Report link is empty');
    }
    
    // Basic URL validation
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      throw new Error('Invalid Monthly Report link format');
    }
    
    return link;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`Failed to fetch Monthly Report link: ${error.message}`);
    }
    throw error;
  }
}

/**
 * Default fallback link for Monthly UBT Reports.
 * Used when the dynamic link fails to load.
 */
export const DEFAULT_MONTHLY_REPORT_LINK = 
  'https://hrconnect.kp.org/wps/mypoc?urile=wcm:path:/myhr/epfsite/nai/workspace/teamtools/ubttrackeradmin/ubtcontent/ubtreportsmonthly';
